import { z } from 'zod';

export const JourneyAlias = z.enum([
  'HEALTH_DEFAULT',
  'MEDICARE_ADVANTAGE',
  'MEDICARE_GENERIC',
  'MEDICARE_SUPPLEMENT',
  '101', // MP-846
  '102', // MP-845
  '103', // MP-925
  '105', // MP-992
]);
export type JourneyAlias = z.infer<typeof JourneyAlias>;
